import { logger } from '../logger/logger.class';
import { LOG_TYPE } from '../const/logger.const';
/**
 * Selects the DOM element as an address for communication
 * @param document `Document` Current window document object
 * @param id `string` unique ID of a DOM element of iFrame
 */
export function getDOMElement(document, id) {
    if (!document) {
        logger.message('Undefined or empty document object', LOG_TYPE.error);
    }
    return document && document.getElementById(id).contentWindow || document.getElementById(id);
}
/**
 * Iframe/Window postMessage util for cross-origin communication between Window objects (popup, iframe)
 * @param targetWindow `Window | HTMLIFrameElement` A reference to the window that will receive the message.
 * @param targetOrigin `string` Required parameter that specifies the origin of `targetWindow`
 * @param message `PostMessage | T` Standarized payload to be sent to destination
 * @param transfer Objects sequence ownership if which is to be transfer to destination
 */
export function publishPost(targetWindow, targetOrigin, message, transfer) {
    logger.message(`Posting message to  ${targetWindow}`, LOG_TYPE.info);
    targetWindow.postMessage(message, targetOrigin, transfer);
}
/**
 * Custom event dispatched to a desired DOM element allowing for communication within an app
 * @param eventName `MessageType` defined message type and custom event name
 * @param payload `T` Payload to be sent to destination
 * @param targetElement `HTMLElement` A reference to the DOM element that will receive the message
 * @param bubbles `boolean` enables event bubbling
 */
export function publishEvent(eventName, payload, targetElement, bubbles = true) {
    logger.message(`Event: ${eventName} dispatched to DOM`, LOG_TYPE.info);
    const event = new CustomEvent(eventName, {
        bubbles,
        detail: payload,
    });
    targetElement.dispatchEvent(event);
}
export const postMessage = {
    getDestination: getDOMElement,
    post: publishPost,
    event: publishEvent,
};
